// extracted by mini-css-extract-plugin
export var completionBody = "_gw-2";
export var completionCard = "_gw-0";
export var completionFooter = "_gw-3";
export var completionTitle = "_gw-1";